package com.flowyride.core.domain.usecase

import com.flowyride.core.domain.geocoding.Geocoder
import com.flowyride.core.domain.model.Place
import com.flowyride.core.domain.util.suspendRunCatching

class SearchPlacesUseCase(private val geocoder: Geocoder) {

    suspend operator fun invoke(query: String): Result<List<Place>> {
        val trimmed = query.trim()
        if (trimmed.length < MIN_QUERY_LENGTH) return Result.success(emptyList())
        return suspendRunCatching { geocoder.search(trimmed, MAX_RESULTS) }
    }

    companion object {
        const val MIN_QUERY_LENGTH = 3
        const val MAX_RESULTS = 5
    }
}
